class BrowserService {
    private _userAgent: string = null;

    public isChrome: boolean = false;
    public isInternetExplorer: boolean = false;
    public isFirefox: boolean = false;
    public isSafari: boolean = false;
    public isOpera: boolean = false;

    private setProperties(): void {
        const CHROME = "Chrome";
        const INTERNET_EXPLORER = "MSIE";
        const INTERNET_EXPLORER_ALT = "rv:";
        const FIREFOX = "Firefox";
        const SAFARI = "Safari";
        const OPERA = "OP";

        this.isFirefox = this.hasAgent(FIREFOX);
        this.isChrome = this.hasAgent(CHROME);
        this.isInternetExplorer = this.hasAgent(INTERNET_EXPLORER) || this.hasAgent(INTERNET_EXPLORER_ALT);
        this.isSafari = this.hasAgent(SAFARI) && !this.isChrome; // Discard Chrome since it also matches Safari
        this.isOpera = this.hasAgent(OPERA) && !this.isChrome; // Discard Chrome since it also matches Opera
    }

    private hasAgent(agentAlias: string): boolean {
        return this._userAgent.indexOf(agentAlias) > -1;
    }

    public init(): void {
        this._userAgent = navigator.userAgent;
        this.setProperties();
    }
}

export const browserService = new BrowserService();
